import React from 'react';

import ProjectDesktopImage from '../../../../components/project/project-desktop-image';
import ProjectFullBanner from '../../../../components/project/project-full-banner';
import ProjectSlider from '../../../../components/project/project-slider';
import ProjectSliderAnimation from '../../../../components/project/project-slider/project-slider-animation';

const AllCladStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectDesktopImage
        desktopImage={acf.desktop_design}
        backgroundColor={acf.desktop_image_background}
        blurb={acf.desktop_design_blurb}
        wrapperPadding={'3rem'}
      />
      <ProjectFullBanner
        image={acf.full_banner_image}
        blurb={acf.full_banner_blurb}
        wrapperPadding={'10vw 0 10vw 0'}
      />
      <ProjectSliderAnimation
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={['0 10vw 10vw 10vw', '0 0 10vw 0']}
      />
    </React.Fragment>
  );
};

export default AllCladStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/all-clad/index.js